export enum StatusCertificadoEnum {
    Nenhum = 0,
    NenhumDescription = 'Nenhum',
    Pendente = 1,
    PendenteDescription = 'Pendente',
    Emitido = 2,
    EmitidoDescription = 'Emitido',
    Revogado = 3,
    RevogadoDescription = 'Revogado',
    Cancelado = 4,
    CanceladoDescription = 'Cancelado'
}

export namespace StatusCertificadoEnum {
    export function values() {
        return Object.keys(StatusCertificadoEnum)
            .filter((type) => isNaN(<any>type) && type !== 'values' && !type.includes('Description') && !type.includes('Nenhum'))
            .map(item => {
                return { enum: +StatusCertificadoEnum[item], description: (StatusCertificadoEnum[item + 'Description']).split(';')[0] };
            });
    }
}
